define('collections/calendar/nutrition/nutrients',[
    'underscore', 'backbone', 'utils',
    // models
    'models/calendar/nutrition/nutrient'
], function(
    // libs
    _, Backbone, U,
    // model
    MNutrient
) {

    var MACRO_NUTRIENT = ['carbohydrate', 'fat', 'protein', 'alcohol'];

    var CNutrients = Backbone.Collection.extend({
        model: MNutrient,

        initialize: function(models, options) {
            this.options = _.extend({
                macro: false
            }, options);
            this._updateMacroTotal();
        },

        getMacroTotal: function() {
            return this.macroTotal;
        },

        /**
         * Nutrient object looks like:
         *
         *    {
         *        alcohol: 0,
         *        calcium: 4.69,
         *        calories: 3.52,
         *        carbohydrate: 0.0625,
         *        cholesterol: 0.16,
         *        ...
         *    }
         */
        getNutrients: function() {
            return this.reduce(this._applyNutrientToObj, {}, this);
        },

        _applyNutrientToObj: function(obj, nutrient) {
            obj[nutrient.id] = nutrient.getValue();
            return obj;
        },

        setNutrients: function(nutrientObj) {
            if (!nutrientObj) return;
            _.each(nutrientObj, this.setTo, this);
            this._updateMacroTotal();
        },
        setTo: function(value, id) {
            var model = this.get(id);
            if (model) model.setValue(value);
        },

        _getMacroProportion: function(total, nutrientName, index) {
            var nutrient = this.get(nutrientName);
            if (nutrient) total += nutrient.getWeightedValue();
            return total;
        },

        _updateMacroTotal: function() {
            this.macroTotal = _.reduce(MACRO_NUTRIENT, this._getMacroProportion, 0, this);
        },

    });

    return CNutrients;
});

